import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
  modelo: z.string().min(1, "Campo obrigatorio"),
  ano: z.string().min(1, "Campo obrigatorio"),
  placa: z.string().optional(),
  chassi: z.string().min(1, "Campo obrigatorio"),
  tipo: z.string().min(1, "Campo obrigatorio"),
});

export type IFormVehicleRegisterV2Values = z.infer<typeof schema>;

export const useFormVehicleRegisterV2 = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IFormVehicleRegisterV2Values>({
    defaultValues: { modelo: "", ano: "", placa: "", chassi: "", tipo: "" },
    resolver: zodResolver(schema),
  });

  return { register, handleSubmit, errors };
};
